import { TQ } from "./actions";
import initialState from "../../../../reducers/initialState";

const TqReducer = (state = initialState, action) => {
  switch (action.type) {
    case TQ.UPDATE_TOTAL_LIST: {
      return {
        ...state,
        tqList: action.tqList,
      };
    }

    case TQ.UPDATE_PENDING_LIST: {
      return {
        ...state,
        pendingTq: action.pendingTq,
      };
    }

    default:
      return state;
  }
};

export default TqReducer;
